<template>
    <div class="form-field">
        <label :for="id"
            >{{ label }} <span v-if="required" class="required">*</span></label
        >
        <input
            v-model="value"
            :name="name"
            type="text"
            placeholder="Your answer"
            :required="required"
            :disabled="is_not_applicable"
            ref="input"
        />
        <span class="error" v-if="error">{{ error }}</span>
        <div class="form-field--not-applicable" v-if="not_applicable">
            <div class="checkbox">
                <div class="form-field checkbox-wrap">
                    <input
                        type="checkbox"
                        v-model="is_not_applicable"
                        :id="`${id}_not_applicable`"
                        :name="`${name}_not_applicable`"
                        @change="onChangeIsNotApplicable"
                    />
                    <label :for="`${id}_not_applicable`">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Not applicable
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IMask from "imask";

export default {
    name: "CurrencyInput",
    data() {
        return {
            value: "",
            is_not_applicable: false,
            maskInput: null,
            maskSettings: {
                mask: "$num",
                lazy: true,
                blocks: {
                    num: {
                        mask: Number,
                        thousandsSeparator: ",",
                        scale: 2,
                        radix: ".",
                        mapToRadix: ["."],
                        padFractionalZeros: true,
                        normalizeZeros: true,
                        min: 0,
                        max: 1000000000,
                    },
                },
            },
        };
    },
    props: [
        "id",
        "label",
        "name",
        "required",
        "setHasErrors",
        "onChange",
        "defaultValue",
        "error",
        "not_applicable",
    ],
    mounted() {
        this.maskInput = new IMask(this.$refs.input, this.maskSettings);

        if (this.defaultValue) {
            this.value = this.defaultValue.value;
            this.is_not_applicable = this.defaultValue.not_applicable;
        }

        if (this.maskInput) {
            this.maskInput.updateValue();
            setTimeout(() => this.$refs.input.focus());
            setTimeout(() => this.$refs.input.blur());
        }
    },
    watch: {
        value: function (val) {
            if (
                this.value &&
                /^\d+(\.\d{1,2})?$/.test(
                    this.value.replace(/,/g, "").replace("$", "")
                )
            ) {
                this.onChange(this.name, {
                    value: this.value.replace(/,/g, "").replace("$", ""),
                    not_applicable: this.is_not_applicable,
                });
            } else if (this.value) {
                return;
            } else {
                this.onChange(this.name, {
                    value: "",
                    not_applicable: this.is_not_applicable,
                });
            }
        },
        is_not_applicable: function (val) {
            this.onChange(this.name, {
                value: "",
                not_applicable: this.is_not_applicable,
            });
        },
    },
    methods: {
        onChangeIsNotApplicable(e) {
            if (e.target.checked) {
                this.is_not_applicable = true;
                this.onChange(this.name, {
                    value: "",
                    not_applicable: this.is_not_applicable,
                });

                this.value = "";
            } else {
                this.is_not_applicable = false;
            }
        },
    },
};
</script>
